import ApiModelWithAuth from "../../../models/ApiModelWithAuth";
import Formatter from "../../../models/Formatter";

export class RoleFormatter extends Formatter {
}

// Роли (CRUD authorized/admin/roles): index/show — всем авторизованным (селект на карточке
// пользователя), create/edit/destroy — только правами admin.roles.* (см. бэк RolesController).
export default class ApiRole extends ApiModelWithAuth {
    pathDef = 'authorized/admin/roles';
    formatterItem = RoleFormatter.Item;
}
